export default __webpack_public_path__ + "static/media/flowersbg2.c36ec65b.png";